var iscroll_page = 1;
var iscroll_loading=false;
var iscroll_end=false;
var iscroll_y = 0;
var iscroll_container;
var iscroll_collection;
var iscroll_initial_item_count=0;

const iscroll_threshold = 300;

iScrollResetY = function(){
	iscroll_y = $('#shopify-section-footer').offset().top;
}


function iScrollInit(c){

  // Mobile infinite scroll disabled per client request; collections use standard numbered pagination instead.
  return;

  iscroll_collection = c;
  

  $(document).ready(
    function(){
      
      if($(window).width()>749) return; // Only mobile!
      
      $('.pagination').hide();
      
      iscroll_initial_item_count = $('.grid__products').find('.grid__item').size();
      
      iScrollResetY();
      
      window.addEventListener('scroll', function() {
        

        var s = $('html').scrollTop() || $('body').scrollTop();
        var x = s+$(window).height();
        
        if(Math.abs(x-iscroll_y)<iscroll_threshold){
          iScrollLoad();
        }
        
        
      });
      
      
      
    }
  );
  
  
}
  
  
function iScrollLoad(){
  
    if(iscroll_loading) return;
    if(iscroll_end) return;
    
  	iscroll_page++;
    
    let u = '/collections/'+iscroll_collection+'/products.json?page='+iscroll_page+'&limit='+iscroll_initial_item_count;

    iscroll_loading=true;
  
    $('.i-scroll-loader').show();
    
    $.get(u, function(r){
      
      
      if(r.products.length==0){
        iscroll_end=true;
        $('.i-scroll-loader').remove();
        return;
      }
      
      let $item = $('.grid__products .grid__item').first();

      for(var i in r.products){
        
        let p = r.products[i];
        
        
        let $clone = $item.clone();
        
        let link = '/products/'+p.handle;
        
        var p_price = -1;
        
        for(var j in p.variants){
          if(p_price<0 || p_price>parseFloat(p.variants[j].price)) p_price=parseFloat(p.variants[j].price);
        }
        
        $clone.find('.product-card__name').text(p.title);
        $clone.find('.product-card__image img').attr('src', '');
        $clone.find('.product-card__image img').attr('src', p.images[0].src);
        $clone.find('.product-card__image img').attr('data-src', p.images[0].src);
        $clone.find('.product-card__image img').attr('srcset', '');
        $clone.find('.product-card__image img').attr('data-srcset', p.images[0].src);
        $clone.find('.product-card__image a').attr('href', link);
        $clone.find('.product-card__price').text('From '+p_price);
        
        $('.grid__products').append($clone);
        
      }
      
      
      $('.i-scroll-loader').hide();
      
      iScrollResetY();
      iscroll_loading=false;
    
    })
    
  }